export default __webpack_public_path__ + "static/cuscapiLogo-9601fc45c7aa9011b5b7865b5e3609ab.png";